import {
    getAbookName,
    setAbookName,
    getIsFree,
    setIsFree,
    getSequence,
    setSequence
} from "utils/storage";
const author = {
    state: {
        bookName: getAbookName(),
        isFree: getIsFree(),
        sequence: getSequence(),
    },
    mutations: {
        SET_BOOKNAME: (state, name) => {
            state.bookName = name;
            setAbookName(name);
        },
        SET_ISFREE: (state, free) => {
            state.isFree = free
            setIsFree(free)
        },
        SET_sequence: (state, sequence) => {
            state.sequence = sequence
            setSequence(sequence)
        }
    },
    actions: {
        //   作品信息
        setAInfo({ commit }, res) {
            commit("SET_BOOKNAME", res.iname);
        },
        setChapterInfo({ commit }, res) {
            // console.log(res)
            commit("SET_ISFREE", res.free);
            commit("SET_sequence", res.sequence);
        },
    }
};
export default author;
